// Shared Morak variant resolution (model + default Tipo de Case priority)
(function () {
  const CASE_TYPE_PRIORITY = [
    "Protección 5m",
    "Protección 3m - Negro",
    "Protección 3m - Blanco",
    "Protección 3m - Crystal",
    "Protección 1.5m",
  ];

  const LS_KEY = "selected_model";

  function norm(s) {
    return String(s || "").trim().toLowerCase().replace(/\s+/g, " ");
  }

  function getSavedModel() {
    try {
      return localStorage.getItem(LS_KEY) || "";
    } catch {
      return "";
    }
  }

  function variantOptions(v) {
    if (Array.isArray(v?.options) && v.options.length) {
      return v.options.map((x) => String(x ?? "").trim());
    }
    return [v?.option1, v?.option2, v?.option3]
      .map((x) => (x == null ? "" : String(x).trim()))
      .filter(Boolean);
  }

  function getModelIndex(product) {
    const idx = (product.options || []).map((o) => norm(o)).indexOf("modelo");
    return idx === -1 ? 0 : idx;
  }

  function getTipoIndex(product) {
    const idx = (product.options || []).map((o) => norm(o)).indexOf("tipo de case");
    return idx === -1 ? 1 : idx;
  }

  function findBestVariant(product, modelLabel) {
    if (!product?.variants?.length || !modelLabel) return null;

    const modelIdx = getModelIndex(product);
    const tipoIdx = getTipoIndex(product);
    const wanted = String(modelLabel).trim();

    const matching = product.variants.filter((v) => {
      if (v.available === false) return false;
      const opts = variantOptions(v);
      return opts[modelIdx] === wanted;
    });

    if (!matching.length) return null;

    for (const pref of CASE_TYPE_PRIORITY) {
      const hit = matching.find((v) => variantOptions(v)[tipoIdx] === pref);
      if (hit) return hit;
    }

    return matching[0];
  }

  function variantMatchesModel(product, variantId, modelLabel) {
    if (!variantId || !modelLabel) return false;
    const variant = product.variants.find((v) => String(v.id) === String(variantId));
    if (!variant) return false;
    const modelIdx = getModelIndex(product);
    return variantOptions(variant)[modelIdx] === String(modelLabel).trim();
  }

  function applyVariantToUrl(url, variantId) {
    const u = new URL(url, window.location.origin);
    u.searchParams.set("variant", String(variantId));
    return u.toString();
  }

  function updateProductLinks(root, product, modelLabel) {
    const variant = findBestVariant(product, modelLabel);
    if (!variant) return null;

    const sample = root.querySelector('a[href*="/products/"]');
    const baseHref = sample?.href || `/products/${product.handle}`;
    const href = applyVariantToUrl(baseHref, variant.id);

    root.querySelectorAll('a[href*="/products/"]').forEach((a) => {
      a.href = href;
    });

    return variant;
  }

  function getSelectedModelLabel() {
    const url = new URL(location.href);
    const fromUrl = url.searchParams.get("filter.v.option.modelo");
    if (fromUrl) return fromUrl;

    try {
      const sel = document.getElementById("global-model-selector");
      if (sel?.value) return sel.value.trim();
    } catch {}

    return getSavedModel();
  }

  const PRODUCT_CACHE = new Map();

  async function fetchProduct(handle) {
    if (PRODUCT_CACHE.has(handle)) return PRODUCT_CACHE.get(handle);

    const promise = fetch(`/products/${handle}.js`, { credentials: "same-origin" })
      .then((r) => {
        if (!r.ok) throw new Error("Failed to fetch product");
        return r.json();
      })
      .catch(() => null);

    PRODUCT_CACHE.set(handle, promise);
    return promise;
  }

  function extractHandle(url) {
    const match = String(url).match(/\/products\/([^?#]+)/);
    return match ? match[1] : null;
  }

  function installProductLinkGuard() {
    document.addEventListener(
      "click",
      async (e) => {
        if (e.defaultPrevented || e.button !== 0) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        const a = e.target.closest?.('a[href*="/products/"]');
        if (!a || a.target === "_blank") return;

        const model = getSelectedModelLabel();
        if (!model) return;

        const handle = extractHandle(a.href);
        if (!handle) return;

        const product = await fetchProduct(handle);
        if (!product) return;

        const best = findBestVariant(product, model);
        if (!best) return;

        const url = new URL(a.href, location.origin);
        if (url.searchParams.get("variant") === String(best.id)) return;

        e.preventDefault();
        location.href = applyVariantToUrl(a.href, best.id);
      },
      true
    );
  }

  window.MorakVariantResolver = {
    CASE_TYPE_PRIORITY,
    variantOptions,
    findBestVariant,
    variantMatchesModel,
    applyVariantToUrl,
    updateProductLinks,
    getSelectedModelLabel,
    getSavedModel,
    fetchProduct,
    extractHandle,
    installProductLinkGuard,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", installProductLinkGuard);
  } else {
    installProductLinkGuard();
  }
})();
